import type { CreateRedirectionAction } from '..';
import { REDIRECTION_CREATE } from '../actionTypes';

const createRedirection = (sophoraId: string): CreateRedirectionAction => ({
	type: REDIRECTION_CREATE,
	payload: sophoraId,
});

export default createRedirection;
